<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-card-title>
        {{ $t("projects.slideManagement.request.title") }}
      </v-card-title>
      <v-card-text>
        {{ $t("projects.slideManagement.request.subtitle") }}

        <v-data-table
          class="table"
          :loading="loading"
          :items="items"
          :headers="selectedHeaders"
          disable-sort
          disable-pagination
          disable-filtering
          hide-default-footer
          v-model="selectedItems"
          @click:row="onClickRow"
          :no-data-text="$t('projects.slideManagement.request.empty')"
        >
          <template v-slot:item.status="{ item }">
            {{ $dp.mapSlideStatus(status(item.status).status) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              small
              text
              v-if="status(item.status).status === 'assigned'"
              @click="updateSlideStatus(item, 'annotations_requested')"
            >
              {{ $t("button.request") }}
            </v-btn>
            <v-btn
              small
              text
              v-if="status(item.status).status === 'annotations_requested'"
              @click="updateSlideStatus(item, 'assigned')"
            >
              {{ $t("button.cancel") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="onClickClose">
          {{ $t("button.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { LIST, LOAD } from "@/store/modules/annotationClass";
import { FIND } from "@/store/modules/status";
import { UPDATE_SLIDE_STATUS } from "@/store/modules/slides";

export default {
  props: {
    value: { type: Boolean, default: false },
    project: { type: Object },
    slide: Object
  },
  data() {
    return {
      dialog: false,
      loadingStack: [],
      selected: [],
      headers: [
        { text: "ID", value: "id", visible: true },
        { text: "Annotation Class", value: "class_name", visible: true },
        { text: "Status", value: "status", visible: true },
        { text: "Actions", value: "actions", visible: true }
      ],
      selectedItems: [],
      items: []
    };
  },
  computed: {
    ...mapState({
      token: state => state.authentication.keycloak.token
    }),
    ...mapGetters({
      list: LIST
    }),
    selectedHeaders() {
      return this.headers.filter(e => e.visible);
    },
    loading() {
      return this.loadingStack.length !== 0;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val;
        this.selected = [];
      }
    },
    list: {
      immediate: true,
      deep: true,
      handler(val) {
        this.prepareItems();
      }
    }
  },
  methods: {
    status(id) {
      // if status is assigned, there is no ID to fetch from the store.
      // just return the assigned status.
      let s = this.$store.getters[FIND](id);
      if (s === undefined) {
        return { status: "assigned" };
      }
      return s;
    },
    prepareItems() {
      this.items = [];
      for (let annotationClass of this.list) {
        const status = this.slide.wholeslideimagestatus_set.find(e => {
          const status = this.status(e);
          if (!status) return false;
          return status.annotation_class === annotationClass.id;
        });
        if (status) {
          annotationClass.status = status;
        } else {
          annotationClass.status = { status: "assigned" };
        }
        this.items.push(annotationClass);
      }
    },
    onClickClose() {
      this.dialog = false;
      this.$emit("input", false);
    },
    onClickRow(item) {
      if (this.selectedItems.findIndex(e => e.id === item.id) > -1) {
        this.selectedItems = this.selectedItems.filter(e => e.id !== item.id);
      } else {
        this.selectedItems.push(item);
      }
    },
    async updateSlideStatus(annotationClass, newStatus) {
      this.loadingStack.push(true);
      const res = await this.$store.dispatch(UPDATE_SLIDE_STATUS, {
        slide: this.slide,
        newStatus,
        annotationClass
      });
      this.prepareItems();
      this.loadingStack.pop();
    }
  },
  async mounted() {
    // if (!this.annotationClassesLoaded) {
    //   this.loadingStack.push(true);
    //   await this.$store.dispatch(LOAD);
    //   this.loadingStack.pop();
    // }
  }
};
</script>

<style lang="css" scoped>
.table ::v-deep tbody tr :hover {
  cursor: pointer;
}
</style>
